<template>
  <div class="protocol">
    Effective Date: May 28, 2025
    <br /><br />

    <div class="bt" style="text-align: center">
      {{ appName }}'s Privacy Policy
    </div>
    <div>
      Welcome to {{ appName }} (the “Platform” or “APP”). The Platform is
      provided and controlled by {{ appName }}. (“{{ appName }}”, “we” or “us”).
      We are committed to protecting and respecting your privacy. This Policy
      explains our practices regarding personal data we collect from you or that
      you provide to us. <br /><br />
      When you use our Services, you consent to our collection and use of
      relevant information in accordance with this Policy. Unless otherwise
      expressly stated in this Privacy Policy, the terms used in this Privacy
      Policy have the same meanings as in our Terms and Conditions.
      <br /><br />
    </div>

    <div class="bt">Definitions</div>
    <div>
      1. Personal Data: refers to data from which a living individual can be
      identified, which may be used alone or in combination with other
      information in our possession or may come into our possession.
      <br /><br />
      2. Usage Data: refers to data automatically generated during your use of
      the Services or from the Services infrastructure itself, such as the
      duration of a page visit.
      <br /><br />
      3. Cookies: are small pieces of data stored on a user's device.
      <br /><br />
      4. Data Controller: refers to the entity that determines the purposes and
      means of processing personal data, either alone or jointly or with others.
      For the purposes of this Privacy Policy, we are the data controller of
      your data.
      <br /><br />
      5. Data Processor (or Service Provider): refers to the entity that
      processes data on behalf of the Data Controller (except the Data
      Controller’s employees). In order to process your data more efficiently,
      we may use the services of various service providers.
      <br /><br />
      6. Data Subject: refers to any living individual who is the subject of
      personal data.
      <br /><br />
      7. User: refers to an individual who uses our services, and the user
      corresponds to the data subject, that is, the subject of personal data.
      <br /><br />
    </div>
    <div class="bt">Information Collection and Use</div>
    <div>
      We collect different types of information for various purposes to provide
      and improve our services to you.
      <br /><br />
      (I) Types of Data Collected
      <br /><br />
      1. Personal Data
      <br /><br />
      When you use our services, we may ask you to provide certain personally
      identifiable information that can be used to contact or identify you
      ("Personal Data"), which may include but is not limited to:
      <br /><br />
      <div class="text_indent">
        Email address
        <br /><br />
        First and last name
        <br /><br />
        Phone number
        <br /><br />
        Address, state, province, zip code, city
        <br /><br />
        Cookies and Usage Data
        <br /><br />
      </div>
      We may use your Personal Data to send you newsletters, marketing or
      promotional materials and other information that may be of interest to
      you. You may opt out of receiving any or all of these communications from
      us by clicking on the unsubscribe link in any email we send or by
      following the instructions in the email.
      <br /><br />
      2. Usage Data
      <br /><br />
      We may also collect information that your browser sends whenever you visit
      our Service or when you access the Service through a mobile device ("Usage
      Data").
      <br /><br />
      This Usage Data may include information such as your computer's network
      interconnect protocol address (such as IP address), browser type, browser
      version, the pages of our Service that you visit, the time and date of
      your visit, the time spent on those pages, unique identifiers and other
      diagnostic data.
      <br /><br />
      When you access the Service through a mobile device, such Usage Data may
      include information such as the type of mobile device you use, mobile
      device unique ID, mobile device IP address, mobile operating system, type
      of mobile Internet browser used, unique identifiers and other diagnostic
      data.
      <br /><br />
      3. Location Data
      <br /><br />
      With your permission, we may use and store information about your location
      ("Location Data") to provide the features of our Service and to improve
      and customize our Service. You can enable or disable location services
      when using our Service at any time through your device settings.
      <br /><br />
      4. Tracking Cookies Data
      <br /><br />
      We use cookies and similar tracking technologies to track activity on our
      Service and store certain information. Cookies are files with small
      amounts of data, which may include an anonymous unique identifier. Cookies
      are sent to your browser from a website and stored on your device.
      Tracking technologies used also include beacons, tags, and scripts to
      collect and track information and to improve and analyze our Services. You
      can instruct your browser to refuse all cookies or to indicate when a
      cookie is being sent. However, if you do not accept cookies, you may not
      be able to use certain features of our Services.
      <br /><br />
      Examples of Cookies We Use:
      <br /><br />
      <div class="text_indent">
        Session Cookies: We use Session Cookies to operate our Services.
        <br />
        Preference Cookies: We use Preference Cookies to remember your
        preferences and various choices.
        <br />

        Security Cookies: We use Security Cookies for security purposes.
      </div>
      <br /><br />
      (II) Use of Data
      <br /><br />
      Our company uses the collected data for various purposes:
      <br /><br />
      <div class="text_indent">
        Provide and maintain our services
        <br />
        Notify you of changes to our services
        <br />
        Allow you to participate when you choose to participate in interactive
        features of our services
        <br />
        Provide customer support
        <br />
        Collect analysis or valuable information so that we can improve our
        services
        <br />
        Monitor the use of our services
        <br />
        Detect, prevent and resolve technical issues
        <br />
        Provide you with news, special offers and general information about
        other goods, services and activities similar to those you have purchased
        or inquired about, unless you choose not to receive such information
        <br />
        <br />
      </div>
    </div>
    <div class="bt ">Data Retention</div>
    <div>
      Our company will only retain your personal data for the period necessary
      for the purposes set out in this Privacy Policy. We will retain and use
      your personal data to meet our legal obligations (for example, if we need
      to retain your data to comply with applicable laws), resolve disputes and
      enforce our legal agreements and policies.
      <br /><br />
      Our company will also retain usage data for internal analysis purposes.
      Usage data is generally retained for a shorter period of time unless the
      data is used to strengthen security or improve the functionality of our
      services or we are legally obligated to retain the data for a longer
      period of time.
      <br /><br />
    </div>
    <div class="bt ">Data Transfer</div>
    <div>
      Your information, including Personal Data, may be transferred to and
      maintained on computers outside of your state, province, country or other
      governmental jurisdiction where the data protection laws may differ than
      those of your jurisdiction. If you are located outside of the United
      States and choose to provide information to us, please be advised that we
      transfer your data, including Personal Data, to the United States and
      process it there. By submitting such information after agreeing to this
      Privacy Policy, you consent to such transfer. The Company will take all
      steps reasonably necessary to ensure that your data is treated securely
      and in accordance with this Privacy Policy. Your Personal Data will not be
      transferred to another organization or country unless there are adequate
      controls in place, including to ensure the security of your data and other
      personal information.
      <br /><br />
    </div>
    <div class="bt subtitle">Data Disclosure</div>
    <div>
      1. Business Transactions: If our company is involved in a merger,
      acquisition or asset sale, your Personal Data may be transferred. We will
      provide notice before your Personal Data is transferred and becomes
      subject to a different privacy policy.
      <br /><br />
      2. Law Enforcement Disclosure: In certain circumstances, the Company may
      need to disclose your Personal Data if required by law or in response to a
      valid request by a public authority (e.g., a court or government agency).
      <br /><br />
      3. Legal Requirements: The Company may disclose your personal data when we
      believe in good faith that it is necessary to:
      <br /><br />
      <div class="text_indent">
        Comply with a legal obligation
        <br />
        Protect and defend the rights or property of our company
        <br />
        To prevent or investigate possible wrongdoing in connection with the
        Service
        <br />
        Protect the personal safety of users of the Service or the public
        <br />
        Prevent legal liability
      </div>
      <br /><br />
    </div>
    <div class="bt ">Data Security</div>
    <div>
      The security of your data is important to us, but remember that no method
      of transmission over the Internet, or method of electronic storage, is
      100% secure. While we strive to use commercially acceptable means to
      protect your personal data, we cannot guarantee its absolute security.
      <br /><br />
    </div>
    <div class="bt ">Your Rights</div>
    <div>
      The Company will take reasonable steps to allow you to correct, amend,
      delete or limit the use of your personal data. Whenever possible, you can
      update your personal data directly in your account settings section. If
      you are unable to change your personal data, please contact us to make the
      necessary changes. If you wish to learn what personal data we hold about
      you or want us to delete it from our systems, please contact us. In
      certain circumstances, you have the right to:
      <br /><br />
      1.Access and receive a copy of the personal data we hold about you
      <br /><br />
      2.Correct any inaccurate personal data we hold about you
      <br /><br />
      3.Request deletion of personal data held about you
      <br /><br />
      You have the right to data portability of information you have provided to
      us. You can request a copy of your personal data in a commonly used
      electronic format so that you can manage and transfer it.
      <br /><br />
      Please note that we may ask you to verify your identity before processing
      such a request.
      <br /><br />
    </div>
    <div class="bt">Service Providers</div>
    <div>
      We may employ third-party companies and individuals to facilitate our
      Services (“Service Providers”), to provide the Services on our behalf, to
      perform Service-related services, or to assist us in analyzing how our
      Services are used. These third parties have access to your personal data
      only to perform these tasks on our behalf and are obligated not to
      disclose or use it for any other purpose.
      <br /><br />
    </div>
    <div class="bt ">Links to Other Websites</div>
    <div>
      Our Services may contain links to other websites that are not operated by
      us. If you click on a third-party link, you will be directed to that
      third-party website. We strongly recommend that you review the privacy
      policy of every website you visit. We have no control over, and assume no
      responsibility for, the content, privacy policies, or practices of any
      third-party websites or services.
      <br /><br />
    </div>
    <div class="bt">Children's Privacy</div>
    <div>
      Our Services are not intended for anyone under the age of 13 ("Children").
      We do not knowingly collect personally identifiable information from
      anyone under the age of 13. If you are a parent or guardian and you are
      aware that your Child has provided us with Personal Data, please contact
      us. If we discover that we have collected Personal Data from a Child
      without verification of parental consent, we will take steps to delete
      that information from our servers.
      <br /><br />
    </div>
    <div class="bt">Changes to this Privacy Policy</div>
    <div>
      e may update our Privacy Policy from time to time. We will notify you of
      any changes by posting the new Privacy Policy on this page. We will notify
      you by email and/or by posting a prominent notice on our Services before
      the changes become effective and update the "Effective Date" at the top of
      this Privacy Policy. You are advised to review this Privacy Policy
      periodically to be aware of any changes. Changes to this Privacy Policy
      are effective when they are posted on this page.
      <br /><br />
    </div>
    <div class="bt">Contact Us</div>
    <div>
      If you have any questions about this Privacy Policy, please contact us at
      {{ appEmail }}.<br /><br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.table-container {
  width: 100%; /* 或任何具体宽度 */
  overflow-x: auto;
}
table {
  border-collapse: collapse; /* 合并边框 */
  max-width: 100%;
  width: 100%;
  margin: 0.2267rem 0; /* 外边距 */
  font-family: Arial, sans-serif; /* 字体 */
}
td {
  padding: 0.2267rem; /* 内边距 */
  border: 1px solid #ddd; /* 边框 */
  word-wrap: break-word; /* 允许长单词换行 */
  white-space: normal; /* 允许内容换行 */
}

.protocol {
  /* overflow: hidden; */
  width: 100%;
  font-size: 0.9rem;
  margin-bottom: 0.4667rem;
  color: #666;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  box-sizing: border-box;
}
.bt {
  font-size: 1.3rem;
  margin: 0.2rem 0px;
  color: #000;
}
.subtitle {
  font-size: 1.1rem;
  color: #333;
}
.text_indent {
  padding-left: 20px;
}
</style>
